import $ from "jquery";

class Candidato {
  constructor(loading) {
    this.loading = loading;
    this.events();
  }

  events() {
    if (document.querySelector("#user-img")) {
      let user_img = document.querySelector(
        "#user-img"
      );

      user_img.addEventListener("change", this.uploadProfile.bind(this));
    }

    if (document.querySelector("#pre-registo-candidato")) {
      let pre_registo_candidato = document.querySelector(
        "#pre-registo-candidato"
      );

      pre_registo_candidato.addEventListener("click", this.preRegistoCandidato.bind(this));
    }

    if (document.querySelector("#update-dados-pessoais")) {
      let update_dados_pessoais = document.querySelector(
        "#update-dados-pessoais"
      );

      update_dados_pessoais.addEventListener(
        "click",
        this.updateDadosPessoais.bind(this)
      );
    }

    if (document.querySelector("#adicionar-habilitacoes-literarias")) {
      let adicionar_habilitacoes_literarias = document.querySelector(
        "#adicionar-habilitacoes-literarias"
      );

      adicionar_habilitacoes_literarias.addEventListener(
        "click",
        this.adicionarHabilitacoesLiterarias.bind(this)
      );
    }

    if (document.querySelector("#adicionar-formacao-mais-emprego")) {
      let adicionar_formacao_mais_emprego = document.querySelector("#adicionar-formacao-mais-emprego");

      adicionar_formacao_mais_emprego.addEventListener(
        "click",
        this.adicionarFormacaoMaisEmprego.bind(this)
      );
    }

    if (document.querySelector("#adicionar-formacao")) {
      let adicionar_formacao = document.querySelector("#adicionar-formacao");

      adicionar_formacao.addEventListener(
        "click",
        this.adicionarFormacao.bind(this)
      );
    }

    if (document.querySelector("#adicionar-idioma")) {
      let adicionar_idioma = document.querySelector("#adicionar-idioma");

      adicionar_idioma.addEventListener(
        "click",
        this.adicionarIdioma.bind(this)
      );
    }

    if (document.querySelector("#adicionar-habilidade")) {
      let adicionar_habilidade = document.querySelector(
        "#adicionar-habilidade"
      );

      adicionar_habilidade.addEventListener(
        "click",
        this.adicionarHabilidade.bind(this)
      );
    }
    
    if (document.querySelector("#adicionar-habilidade-comportamental")) {
      let adicionar_habilidade = document.querySelector(
        "#adicionar-habilidade-comportamental"
      );

      adicionar_habilidade.addEventListener(
        "click",
        this.adicionarHabilidadeComportamental.bind(this)
      );
    }

    if (document.querySelector("#adicionar-ex-profissional")) {
      let adicionar_ex_profissional = document.querySelector(
        "#adicionar-ex-profissional"
      );

      adicionar_ex_profissional.addEventListener(
        "click",
        this.adicionarExProfissional.bind(this)
      );
    }

    if (document.querySelector("#add-idioma")) {
      this.add_idioma = document.querySelector("#add-idioma");

      this.add_idioma.addEventListener(
        "click",
        this.handleAddIdioma.bind(this)
      );
    }

    if (document.querySelector("#cancelar-idioma")) {
      this.cancelar_idioma = document.querySelector("#cancelar-idioma");

      this.cancelar_idioma.addEventListener(
        "click",
        this.handleAddIdioma.bind(this)
      );
    }

    if (document.querySelector("#add-habilitacao")) {
      this.add_habilidade = document.querySelector("#add-habilitacao");

      this.add_habilidade.addEventListener(
        "click",
        this.handleAddHabilitacao.bind(this)
      );
    }

    if (document.querySelector("#cancelar-habilitacao")) {
      
      this.cancel_habilidade = document.querySelector("#cancelar-habilitacao");

      this.cancel_habilidade.addEventListener(
        "click",
        this.handleAddHabilitacao.bind(this)
      );
    }

    if (document.querySelector("#add-habilidade-comportamental")) {
      this.add_habilidade = document.querySelector("#add-habilidade-comportamental");

      this.add_habilidade.addEventListener(
        "click",
        this.handleAddHabilidadeComportamental.bind(this)
      );
    }
    
    if (document.querySelector("#add-habilidade")) {
      this.add_habilidade = document.querySelector("#add-habilidade");

      this.add_habilidade.addEventListener(
        "click",
        this.handleAddHabilidade.bind(this)
      );
    }

    if (document.querySelector("#cancelar-habilidade-comportamental")) {
      this.cancelar_habilidade = document.querySelector("#cancelar-habilidade-comportamental");
      this.cancelar_habilidade.addEventListener(
        "click",
        this.handleAddHabilidadeComportamental.bind(this)
      );
    }

    if (document.querySelector("#cancelar-habilidade")) {
      this.cancelar_habilidade = document.querySelector("#cancelar-habilidade");
      this.cancelar_habilidade.addEventListener(
        "click",
        this.handleAddHabilidade.bind(this)
      );
    }
    
    if (document.querySelector("#limpar-filtros")) {
      this.limpar_filtros = document.querySelector("#limpar-filtros");
      this.limpar_filtros.addEventListener(
        "click",
        this.limparFiltros.bind(this)
      );
    }

    if (document.querySelector("#add-formacao-mais-emprego")) {
      let add_formacao_mais_emprego = document.querySelector("#add-formacao-mais-emprego");
     
      add_formacao_mais_emprego.addEventListener("click", this.handleAddFormacaoMaisEmprego.bind(this));
    }

    if (document.querySelector("#cancelar-formacao-mais-emprego")) {
      let cancelar_formacao_mais_emprego = document.querySelector("#cancelar-formacao-mais-emprego");
          cancelar_formacao_mais_emprego.addEventListener("click", this.handleAddFormacaoMaisEmprego.bind(this));
    }

    if (document.querySelector("#add-formacao")) {
      let add_formacao = document.querySelector("#add-formacao");

      add_formacao.addEventListener("click", this.handleAddFormacao.bind(this));
    }

    if (document.querySelector("#cancelar-formacao")) {
      let cancelar_formacao = document.querySelector("#cancelar-formacao");

      cancelar_formacao.addEventListener("click", this.handleAddFormacao.bind(this));
    }

    if (document.querySelector("#add-ex-profissional")) {
      let add_ex_profissional = document.querySelector("#add-ex-profissional");

      add_ex_profissional.addEventListener(
        "click",
        this.handleAddExProfissional.bind(this)
      );
    }
   
    if (document.querySelector("#cancelar-ex-profissional")) {
      let cancelar_ex_profissional = document.querySelector("#cancelar-ex-profissional");

      cancelar_ex_profissional.addEventListener(
        "click",
        this.handleAddExProfissional.bind(this)
      );
    }

    if (document.querySelector("#habilitacao-group")) {
      $("#habilitacao-group").on("click", ".delete-habilitacao", (e) =>
        this.deleteHabilitacao(e)
      );
    }

    if (document.querySelector("#formacao-mais-emprego-group")) {
      $("#formacao-mais-emprego-group").on("click", ".delete-formacao-mais-emprego", (e) =>
        this.deleteFormacaoMaisEmprego(e)
      );
    }

    if (document.querySelector("#formacao-group")) {
      $("#formacao-group").on("click", ".delete-formacao", (e) =>
        this.deleteFormacao(e)
      );
    }

    if (document.querySelector("#idioma-group")) {
      $("#idioma-group").on("click", ".delete-idioma", (e) =>
        this.deleteIdioma(e)
      );
    }

    if (document.querySelector("#habilidade-group")) {
      $("#habilidade-group").on("click", ".delete-habilidade", (e) =>
        this.deleteHabilidade(e)
      );
    }

    if (document.querySelector("#habilidade-comportamental-group")) {
      $("#habilidade-comportamental-group").on("click", ".delete-habilidade-comportamental", (e) =>
        this.deleteHabilidadeComportamental(e)
      );
    }

    if (document.querySelector("#ex-profissional-group")) {
      $("#ex-profissional-group").on("click", ".delete-ex-profissional", (e) =>
        this.deleteExProfissional(e)
      );
    }

    if (document.querySelector("#search-candidato")) {
      let search_candidato = document.querySelector("#search-candidato");
      search_candidato.addEventListener(
        "keyup",
        this.searchCandidato.bind(this)
      );
    }

    if (document.querySelector("#search-potenciais-candidatos")) {
      let search_candidato = document.querySelector("#search-potenciais-candidatos");
      search_candidato.addEventListener(
        "keyup",
        this.searchPotenciaisCandidato.bind(this)
      );
    }

    if (document.querySelector(".buscar-candidatos")) {
      //  let search_candidato = document.querySelector(".buscar-candidatos");
      //   search_candidato.addEventListener("keyup", this.searchCandidato.bind(this));

      $(".buscar-candidatos").on("change", this.searchCandidato.bind(this));

      if(document.getElementById("buscar-candidatos")){
        this.searchCandidato();
      }

      $(".keyup").on("keyup", this.searchCandidato.bind(this));
    }
  }


  uploadProfile(){
    this.loading.showLoadingAnimation();

    let formData = new FormData();
    let profileInput = document.getElementById("user-img");
    let profile_img = profileInput.files[0];
    formData.append("profile_img", profile_img);

    $.ajax({
      url: maisempregoData.root_url + "/wp-json/maisemprego/profile/v1/upload",
      method: "POST",
      data: formData,
      processData: false,
      contentType: false,
      beforeSend: xhr => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
     
      success: (response) => {
        console.log(response);

        console.log(response.data.uploadedFiles.url);

        $('#perfil_icon').addClass("d-none")

        $("#perfil_img").attr("src", response.data.uploadedFiles.url);
        this.loading.hideLoadingAnimation()
        
      },
      error:  error => {
        console.log(error);
        this.loading.hideLoadingAnimation()
      },
    });

  }

  limparFiltros(){
    const selectElements = document.querySelectorAll('select');
    selectElements.forEach(function (select) {
      select.selectedIndex = 0;
    });

    $('#distrito').val('')

    this.searchCandidato();
  }


  searchPotenciaisCandidato() {

    let search = $("#search-potenciais-candidatos").val()

    
    $.ajax({
      url:
        maisempregoData.root_url + "/wp-json/maisemprego/candidato/v1/potenciais/search",
      method: "POST",
      beforeSend: function (xhr) {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      data: {search},
      success: (response) => {
        $("#cadidatos-list").html(this.candidatoHtml(response));
      },
      error: function (error) {
        console.log("O correu um erro durante a pesquisa do usuário");
        console.log(error);
      },
    });
  }

  searchCandidato() {
    let search = $("#search-candidato").val()
      ? $("#search-candidato").val()
      : "";
    let idade_minima = $("#idade_minima").val() ? $("#idade_minima").val() : "";
    let idade_maxima = $("#idade_maxima").val() ? $("#idade_maxima").val() : "";
    let formacao = $("#formacao").val() ? $("#formacao").val() : "";
    let nivel_academico = $("#nivel_academico").val()
      ? $("#nivel_academico").val()
      : "";
    let tipo_de_candidato = $("#tipo_de_candidato").val()
      ? $("#tipo_de_candidato").val()
      : "";
    let anos_de_experiencia = $("#anos_de_experiencia").val()
      ? $("#anos_de_experiencia").val()
      : "";
    let distrito = $("#distrito").val() ? $("#distrito").val() : "";
    let provincia = $("#provincia").val() ? $("#provincia").val() : "";


    let data;
    if(document.getElementById("buscar-candidatos")){
         data ={
          search,
          idade_minima,
          idade_maxima,
          formacao,
          nivel_academico,
          tipo_de_candidato,
          anos_de_experiencia,
          distrito,
          provincia,
        }
    }else{
       data = {
        search
      }
    }

    
    
    $.ajax({
      url:
        maisempregoData.root_url + "/wp-json/maisemprego/candidato/v1/search",
      method: "POST",
      beforeSend: function (xhr) {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      data: data,
      success: (response) => {
        $("#cadidatos-list").html(this.candidatoHtml(response));

          this.filterCountResult(response)        
      },
      error: function (error) {
        console.log("Error creating user.");
        console.log(error);
      },
    });
  }


  filterCountResult(response){
    let formmacoes = [];
    let formacoes_valores = {};

    $.ajax({
      type: "GET",
      url: maisempregoData.root_url + "/wp-json/wp/v2/formacao/",
      dataType: "json",
      async: false,
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      success: (response) => {
          formmacoes= response;
      },
      error: (response) => {
        
      },
    });


    formmacoes.map(formacao =>{
      formacoes_valores[`formacao_${formacao.id}`] = 0;
    });
   

    let licenciatura =0
    let ensino_tecnico =0
    let ensino_medio =0
    let primeiro_emprego =0
    let desempregado_1 =0
    let desempregado_mais_1 =0
    let conta_propria =0
    let nenhuma_experiencia =0
    let menos_6meses =0
    let entre_6meses_1ano =0
    let entre_1ano_3ano =0
    let mais_de_3anos =0

    let maputo_cidade = 0;
    let maputo_provincia = 0;
    let gaza = 0;
    let inhambane = 0;
    let sofala = 0;
    let manica = 0;
    let tete = 0;
    let zambezia = 0;
    let nampula = 0;
    let niassa = 0;
    let cabo_delgado = 0;

    response.map(candidato => {

      formmacoes.map(formacao =>{
        if(candidato.formacao_mais_emprego == formacao.acf.formacao ){
          formacoes_valores[`formacao_${formacao.id}`] = ++formacoes_valores[`formacao_${formacao.id}`];
         }
      });

       
       if(candidato.nivel_academico == 'Licenciatura'){
        licenciatura++;
       }else if(candidato.nivel_academico == 'Ensino Técnico'){
        ensino_tecnico++;
       } else if(candidato.nivel_academico == 'Ensino Médio'){
        ensino_medio++;
       } 

       if(candidato.tipo_de_candidato == 'A procura do 1º emprego'){
        primeiro_emprego++;
       }else if(candidato.tipo_de_candidato == 'Desempregado há mais de um ano'){
        desempregado_mais_1++;
       } else if(candidato.tipo_de_candidato == 'Empregado por conta própria'){
        conta_propria++;
       } 


       if(candidato.anos_de_experiencia == 'Nenhuma experiência'){
        nenhuma_experiencia++;
       }else if(candidato.anos_de_experiencia == 'Menos de 6 meses'){
        menos_6meses++;
       } else if(candidato.anos_de_experiencia == 'Entre 6 meses à 1 ano'){
        entre_6meses_1ano++;
       } else if(candidato.anos_de_experiencia == 'Entre 1 ano à 3 anos'){
        entre_1ano_3ano++;
       } else if(candidato.anos_de_experiencia == 'Mais de 3 anos'){
        mais_de_3anos++;
       }

       if(candidato.provincia == 'Maputo (cidade)'){
        maputo_cidade++;
       }else if(candidato.provincia == 'Maputo (província)'){
        maputo_provincia++;
       } else if(candidato.provincia == 'Gaza'){
        gaza++;
       } else if(candidato.provincia == 'Inhambane'){
        inhambane++;
       } else if(candidato.provincia == 'Sofala'){
        sofala++;
       } else if(candidato.provincia == 'Manica'){
        manica++;
       } else if(candidato.provincia == 'Tete'){
        tete++;
       } else if(candidato.provincia == 'Zambézia'){
        zambezia++;
       } else if(candidato.provincia == 'Nampula'){
        nampula++;
       } else if(candidato.provincia == 'Niassa'){
        niassa++;
       } else if(candidato.provincia == 'Cabo Delgado'){
        cabo_delgado++;
       } 
    });

    
    
      formmacoes.map(formacao =>{
        $(`#formacao_${formacao.id}`).html(`${formacao.acf.formacao} (${ formacoes_valores[`formacao_${formacao.id}`]})`)
      });
    
      
      $('#licenciatura').html(`Licenciatura (${licenciatura})`)
      $('#ensino_tecnico').html(`Ensino Técnico (${ensino_tecnico})`)
      $('#ensino_medio').html(`Ensino Médio (${ensino_medio})`)
      $('#primeiro_emprego').html(`A procura do 1º emprego (${primeiro_emprego})`)
      $('#desempregado_1').html(`Desempregado há menos de 1 ano (${desempregado_1})`)
      $('#desempregado_mais_1').html(`Desempregado há mais de um ano (${desempregado_mais_1})`)
      $('#conta_propria').html(`Empregado por conta própria (${conta_propria})`)
      $('#nenhuma_experiencia').html(`Nenhuma experiência (${nenhuma_experiencia})`)
      $('#menos_6meses').html(`Menos de 6 meses (${menos_6meses})`)
      $('#entre_6meses_1ano').html(`Entre 6 meses à 1 ano (${entre_6meses_1ano})`)
      $('#entre_1ano_3ano').html(`Entre 1 ano à 3 anos (${entre_1ano_3ano})`)
      $('#mais_de_3anos').html(`Mais de 3 anos (${mais_de_3anos})`)

      $('#maputo_cidade').html(`Maputo (cidade) ${maputo_cidade}`)
      $('#maputo_provincia').html(`Maputo (província) ${maputo_provincia}`)
      $('#gaza').html(`Gaza ${gaza}`)
      $('#inhambane').html(`Inhambane ${inhambane}`)
      $('#sofala').html(`Sofala ${sofala}`)
      $('#manica').html(`Manica ${manica}`)
      $('#tete').html(`Tete ${tete}`)
      $('#zambezia').html(`Zambézia ${zambezia}`)
      $('#nampula').html(`Nampula ${nampula}`)
      $('#niassa').html(`Niassa ${niassa}`)
      $('#cabo_delgado').html(`Cabo Delgado ${cabo_delgado}`)

  }



  candidatoHtml(candidatos) {
   
    let html = "";
   
    if (candidatos.length) {
      candidatos.map((candidato) => {
        $("#cadidatos-list").addClass("space-between");
        html += `

        <a href="${candidato.link ? candidato.link : ""}">
          <div class="student__card">
            <div class="student__card-up">
                <img src="${
                  (candidato.perfil_img)? candidato.perfil_img: maisempregoData.fileUrl+"/img/icons/do-utilizador.png"
                }" alt=""> 
            </div>
    
            <div class="student__card-bottom">
                <h2 class="title">${
                  candidato.nome_do_candidato ? candidato.nome_do_candidato : ""
                } </h2>
    
                <strong> Formação académica: </strong> <span> ${
                  candidato.profissao ? candidato.profissao : ""
                }</span> <br>
                <strong> Nível académico: </strong> <span>  ${
                  candidato.nivel_academico ? candidato.nivel_academico : ""
                }</span> <br>
                <strong>Formação Mais Emprego: </strong> <span>  ${
                  candidato.formacao_mais_emprego
                    ? candidato.formacao_mais_emprego
                    : ""
                }</span>
            </div>
          </div>
        </a>
    
        `;
      });
    } else {
      $("#cadidatos-list").removeClass("space-between");
      html += `
        <div class="centered h-25 w-100"  >
            <h2 class="text-secondary">Nenhum estudante foi encontrado!</h2>
        </div>
      `;
    }

    return html;
  }

  preRegistoCandidato() {

    Swal.fire({
      title: "Confirmar",
      text: "Tens certeza que queres proceder?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Continuar",
      cancelButtonText: "Cancelar",
      customClass: {
        content: "my-swal-content",
        popup: "my-swal-container",
        confirmButton: "confirm-swal-button",
        cancelButton: "cancel-swal-button",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Get user input values
        let nome_do_candidato = $("#nome").val();
        let username = nome_do_candidato.replace(" ", ".").toLocaleLowerCase();
        let email = $("#email").val();
        let role = "candidato"; // Role ID or slug

        let postID = $("#post_id").val();
        
        this.loading.showLoadingAnimation()
        if (nome_do_candidato && username && email) {
          $.ajax({
            url:
              maisempregoData.root_url +
              "/wp-json/maisemprego/user/v1/create-user",
            method: "POST",
            beforeSend: function (xhr) {
              xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
            },
            data: {
              username: username,
              email: email,
              roles: [role], // Set the desired role for the user
            },
            success: user_id => {

              let data = {
                title: nome_do_candidato,
                status: "publish",
                acf: {
                  nome_do_candidato,
                  email,
                  formacao_mais_emprego: $("#formacao_mais_emprego").val(),
                  user: user_id,
                  activo: 1,
                },
              };

              $.ajax({
                beforeSend: (xhr) => {
                  xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
                },
                url: maisempregoData.root_url + "/wp-json/wp/v2/candidato/",
                type: "POST",
                data: data,
                success: (response) => {
                  this.loading.hideLoadingAnimation()
                  $("#nome").val("");
                  $("#username").val("");
                  $("#pwd").val("");
                  $("#email").val("");
                  $("#formacao_mais_emprego").val(""),
                    Swal.fire(
                      "Sucesso!",
                      "Candidato cadastrado com sucesso!",
                      "success"
                    );
                },
                error: (response) => {
                  this.loading.hideLoadingAnimation()
                  console.log("Sorry");
                  console.log(response);
                },
              });
            },
            error: (error) => {
              this.loading.hideLoadingAnimation()
              console.log("Error creating user.");
              console.log(error);
            },
          });
        } else {
          Swal.fire({
            title: "Error",
            text: "Preencha correctamente todos os campos!",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  }

  updateDadosPessoais() {


    

    let dados = {
      acf: {
        nivel_academico: $("#nivel_academico").val(),
        nome_do_candidato: $("#nome_do_candidato").val(),
        profissao: $("#profissao").val(),
        telefone_principal: $("#telefone_principal").val(),
        telefone_alternativo: $("#telefone_alternativo").val(),
        email: $("#email").val(),
        data_de_nascimento: $("#data_de_nascimento").val(),
        tipo_de_candidato: $("#tipo_de_candidato").val(),
        anos_de_experiencia: $("#anos_de_experiencia").val(),
        provincia: $("#provincia").val(),
        distrito: $("#distrito").val(),
        cidade: $("#cidade").val(),
        avenida: $("#avenida").val(),
        bairro: $("#bairro").val(),
        genero: $("#genero").val(),
        bi: $("#bi").val(),
        estado_civil: $("#estado_civil").val(),
        descricao_perfil: $("#descricao_perfil").val(),
        perfil_img: $("#perfil_img").attr("src"),
      },
    };

    
    if(
      dados.acf.nivel_academico &&
      dados.acf.nome_do_candidato &&
      dados.acf.profissao &&
      dados.acf.telefone_principal &&
      dados.acf.email &&
      dados.acf.data_de_nascimento &&
      dados.acf.tipo_de_candidato &&
      dados.acf.anos_de_experiencia &&
      dados.acf.provincia &&
      dados.acf.distrito &&
      dados.acf.cidade &&
      dados.acf.avenida &&
      dados.acf.bairro &&
      dados.acf.genero &&
      dados.acf.bi &&
      dados.acf.estado_civil
      ){
        this.actualizarCandidato(dados);
      }else{ 
        Swal.fire({
          text: "Preencha correctamente todos os campos obrigatórios",
          icon: "error",
          confirmButtonText: "OK",
        });
      }

    

  }

  adicionarHabilitacoesLiterarias() {
    let divCampos = document.querySelectorAll(".habilitacao-literaria");

    let index = 1;
    let camposPreenchidos = [];
    for (let campo of divCampos) {
      if (!$(campo).data("campo")) {
        break;
      }
      camposPreenchidos.push($(campo).data("campo"));
    }

    for(let i =1 ; i <=3; i++){
       if(!camposPreenchidos.includes(i)){
          index = i;
          break;
       }
    }


    let dados = {
      acf: {},
    };

    (dados.acf[`habilitacoes_literarias_nivel_${index}`] = $(
      "#habilitacoes_literarias_nivel"
    ).val()),
      (dados.acf[`habilitacoes_literarias_instituicao_${index}`] = $(
        "#habilitacoes_literarias_instituicao"
      ).val()),
      (dados.acf[`habilitacoes_literarias_formacao_${index}`] = $(
        "#habilitacoes_literarias_formacao"
      ).val()),

      (dados.acf[`habilitacoes_literarias_duracao_${index}`] = $(
        "#habilitacoes_literarias_duracao"
      ).val()),
      this.actualizarCandidato(dados, ["habilitacao", index]);
  }

  adicionarFormacaoMaisEmprego() {
    let divCampos = document.querySelectorAll(".formacao-mais-emprego");

    let index = 1;
    let camposPreenchidos = [];
    for (let campo of divCampos) {
      if (!$(campo).data("campo")) {
        break;
      }
      camposPreenchidos.push($(campo).data("campo"));
    }

    for(let i =1 ; i <=5; i++){
       if(!camposPreenchidos.includes(i)){
          index = i;
          break;
       }
    }


    let dados = {
      acf: {},
    };

    (dados.acf[`formacao_mais_emprego_centro_${index}`] = $(
      "#formacao_mais_emprego_centro"
    ).val()),
      (dados.acf[`formacao_mais_emprego_curso_${index}`] = $(
        "#formacao_mais_emprego_curso"
      ).val()),
      (dados.acf[`formacao_mais_emprego_descricao_${index}`] = $(
        "#formacao_mais_emprego_descricao"
      ).val()),
      (dados.acf[`formacao_mais_emprego_duracao_${index}`] = $(
        "#formacao_mais_emprego_duracao"
      ).val()),
      this.actualizarCandidato(dados, ["formacao-mais-emprego", index]);
  }

  adicionarFormacao() {
    let divCampos = document.querySelectorAll(".outras-formacoes");

    let index = 1;
    let camposPreenchidos = [];
    for (let campo of divCampos) {
      if (!$(campo).data("campo")) {
        break;
      }
      camposPreenchidos.push($(campo).data("campo"));
    }

    for(let i =1 ; i <=3; i++){
       if(!camposPreenchidos.includes(i)){
          index = i;
          break;
       }
    }


    let dados = {
      acf: {},
    };

    (dados.acf[`outras_formacoes_centro_${index}`] = $(
      "#outras_formacoes_centro"
    ).val()),
      (dados.acf[`outras_formacoes_curso_${index}`] = $(
        "#outras_formacoes_curso"
      ).val()),
      (dados.acf[`outras_formacoes_descricao_${index}`] = $(
        "#outras_formacoes_descricao"
      ).val()),
      (dados.acf[`outras_formacoes_duracao_${index}`] = $(
        "#outras_formacoes_duracao"
      ).val()),
      this.actualizarCandidato(dados, ["formacao", index]);
  }

  adicionarExProfissional() {
    let divCampos = document.querySelectorAll(".ex-profissional");

    let index = 1;
    let camposPreenchidos = [];
    for (let campo of divCampos) {
      if (!$(campo).data("campo")) {
        break;
      }
      camposPreenchidos.push($(campo).data("campo"));
    }

    for(let i =1 ; i <=3; i++){
       if(!camposPreenchidos.includes(i)){
          index = i;
          break;
       }
    }


    let dados = {
      acf: {},
    };

    (dados.acf[`experiencia_profissional_empresa_${index}`] = $(
      "#experiencia_profissional_empresa"
    ).val()),
      (dados.acf[`experiencia_profissional_funcao_${index}`] = $(
        "#experiencia_profissional_funcao"
      ).val()),
      (dados.acf[`experiencia_profissional_duracao_${index}`] = $(
        "#experiencia_profissional_duracao"
      ).val()),
      (dados.acf[`experiencia_profissional_descricao_${index}`] = $(
        "#experiencia_profissional_descricao"
      ).val()),

      this.actualizarCandidato(dados, ["ex-profissional", index]);
  }

  adicionarIdioma() {
    let divCampos = document.querySelectorAll(".idiomas");

    let index = 1;

    let camposPreenchidos = [];
    for (let campo of divCampos) {
      if (!$(campo).data("campo")) {
        break;
      }
      camposPreenchidos.push($(campo).data("campo"));
    }

    for(let i =1 ; i <=5; i++){
       if(!camposPreenchidos.includes(i)){
          index = i;
          break;
       }
    }


    let dados = {
      acf: {},
    };

    dados.acf[`idioma_${index}`] = $("#idioma").val();
    dados.acf[`class_idioma_${index}`] = $("#class_idioma").val();

    this.actualizarCandidato(dados, ["idioma", index]);
  }

  adicionarHabilidade() {
    let divCampos = document.querySelectorAll(".habilidades");

    let index = 1;
    let camposPreenchidos = [];
    for (let campo of divCampos) {
      if (!$(campo).data("campo")) {
        break;
      }
      camposPreenchidos.push($(campo).data("campo"));
    }

    for(let i =1 ; i <=3; i++){
       if(!camposPreenchidos.includes(i)){
          index = i;
          break;
       }
    }


    let dados = {
      acf: {},
    };

    dados.acf[`habilidade_${index}`] = $("#habilidade").val();
    dados.acf[`class_habilidade_${index}`] = $("#class_habilidade").val();

    this.actualizarCandidato(dados, ["habilidade", index]);
  }

  adicionarHabilidadeComportamental() {
    let divCampos = document.querySelectorAll(".habilidades-comportamentais");

    let index = 1;
    let camposPreenchidos = [];
    for (let campo of divCampos) {
      if (!$(campo).data("campo")) {
        break;
      }
      camposPreenchidos.push($(campo).data("campo"));
    }

    for(let i =1 ; i <=3; i++){
       if(!camposPreenchidos.includes(i)){
          index = i;
          break;
       }
    }


    let dados = {
      acf: {},
    };

    dados.acf[`habilidade_comportamental_${index}`] = $("#habilidade_comportamental").val();

    this.actualizarCandidato(dados, ["habilidade-comportamental", index]);
  }

  deleteHabilitacao(e) {
    let index = $(e.target).data("campo");
    let dados = {
      acf: {},
    };

    dados.acf[`habilitacoes_literarias_nivel_${index}`] = "";
    dados.acf[`habilitacoes_literarias_instituicao_${index}`] = "";
    dados.acf[`habilitacoes_literarias_formacao_${index}`] = "";

    this.actualizarCandidato(dados, ["habilitacao", null, e.target]);
  }

  deleteIdioma(e) {
    let index = $(e.target).data("campo");
    let dados = {
      acf: {},
    };

    dados.acf[`class_idioma_${index}`] = "";
    dados.acf[`idioma_${index}`] = "";

    this.actualizarCandidato(dados, ["idioma", null, e.target]);
  }

  deleteHabilidade(e) {
    let index = $(e.target).data("campo");
    let dados = {
      acf: {},
    };

    dados.acf[`class_habilidade_${index}`] = "";
    dados.acf[`habilidade_${index}`] = "";

    this.actualizarCandidato(dados, ["habilidade", null, e.target]);
  }

  deleteHabilidadeComportamental(e) {
    let index = $(e.target).data("campo");
    let dados = {
      acf: {},
    };

    dados.acf[`habilidade_comportamental_${index}`] = "";

    this.actualizarCandidato(dados, ["habilidade-comportamental", null, e.target]);
  }

  deleteFormacaoMaisEmprego(e) {
    let index = $(e.target).data("campo");
    let dados = {
      acf: {},
    };

    dados.acf[`formacao_mais_emprego_centro_${index}`] = "";
    dados.acf[`formacao_mais_emprego_curso_${index}`] = "";
    dados.acf[`formacao_mais_emprego_descricao_${index}`] = "";

    this.actualizarCandidato(dados, ["formacao-mais-emprego", null, e.target]);
  }

  deleteFormacao(e) {
    let index = $(e.target).data("campo");
    let dados = {
      acf: {},
    };

    dados.acf[`outras_formacoes_centro_${index}`] = "";
    dados.acf[`outras_formacoes_curso_${index}`] = "";
    dados.acf[`outras_formacoes_descricao_${index}`] = "";

    this.actualizarCandidato(dados, ["formacao", null, e.target]);
  }

  deleteExProfissional(e) {
    let index = $(e.target).data("campo");
    let dados = {
      acf: {},
    };

    dados.acf[`experiencia_profissional_empresa_${index}`] = "";
    dados.acf[`experiencia_profissional_duracao_${index}`] = "";
    dados.acf[`experiencia_profissional_funcao_${index}`] = "";
    dados.acf[`experiencia_profissional_descricao_${index}`] = "";

    this.actualizarCandidato(dados, ["ex-profissional", null, e.target]);
  }

  resetFormacaoMaisEmprego(args) {
    let index = args[1];

    if (index) {
      let htmlData = `
      <div class="formacao-mais-emprego" data-campo="${index}">
      <div class="text-right">
          <i data-campo="${index}" class="fa-sharp fa-solid fa-circle-xmark delete-formacao-mais-emprego text-red"></i>
      </div>

      <div class="form-group ">
          <label for="">Centro/Instituição</label>
          <input readonly="text" name="formacao_mais_emprego_centro_${index}" id="formacao_mais_emprego_centro_${index}" value="${$(
        "#formacao_mais_emprego_centro"
      ).val()}" placeholder="Digita o nome do curso" />

      </div>

      <div class="form-group ">
          <label for="">Curso</label>
          <input readonly="text" name="formacao_mais_emprego_curso_${index}" id="formacao_mais_emprego_curso_${index}" value="${$(
        "#formacao_mais_emprego_curso"
         ).val()}" placeholder="Digita o nome do curso" />

      </div>

      <div class="form-group ">
          <label for="">Duração (MM/AAAA - MM/AAAA)</label>
          <input readonly type="text" name="formacao_mais_emprego_duracao_${index}" id="formacao_mais_emprego_duracao_${index}" value="${$(
            "#formacao_mais_emprego_duracao"
             ).val()}" placeholder="01/2020 - 12/2022" />

      </div>

      <div class="form-group ">
          <label for="">Descrição</label>
          <textarea readonly name="formacao_mais_emprego_descricao_${index}" id="formacao_mais_emprego_descricao_${index}" cols="30" rows="3">${$(
        "#formacao_mais_emprego_descricao"
      ).val()}</textarea>
      </div>

      <hr class="mt mb">
  </div>
      
      `;

      $("#formacao-mais-emprego-group").append(htmlData);
      $("#formacao_mais_emprego_centro").val("");
      $("#formacao_mais_emprego_curso").val("");
      $("#formacao_mais_emprego_descricao").val("");
      $("#formacao_mais_emprego_duracao").val("");
      
      this.handleAddFormacaoMaisEmprego();
    } else {
      let element = args[2];
      $(element).parent().parent().remove();
    }

    let divCampos = document.querySelectorAll(".formacao-mais-emprego");

    let limit = 0;
    for (let campo of divCampos) {
      if ($(campo).data("campo")) {
        limit++;
      }
    }

    if (limit == 5) {
      $("#add-formacao-mais-emprego").addClass("d-none");
    } else {
      $("#add-formacao-mais-emprego").removeClass("d-none");
    }
  }

  resetFormacao(args) {
    let index = args[1];

    if (index) {
      let htmlData = `
      <div class="outras-formacoes" data-campo="${index}">
      <div class="text-right">
          <i data-campo="${index}" class="fa-sharp fa-solid fa-circle-xmark delete-formacao text-red"></i>
      </div>

      <div class="form-group ">
          <label for="">Centro/Instituição</label>
          <input readonly="text" name="outras_formacoes_centro_${index}" id="outras_formacoes_centro_${index}" value="${$(
        "#outras_formacoes_centro"
      ).val()}" placeholder="Digita o nome do curso" />

      </div>

      <div class="form-group ">
          <label for="">Curso</label>
          <input readonly="text" name="outras_formacoes_curso_${index}" id="outras_formacoes_curso_${index}" value="${$(
        "#outras_formacoes_curso"
      ).val()}" placeholder="Digita o nome do curso" />

      </div>

      <div class="form-group ">
      <label for="">Duração (MM/AAAA - MM/AAAA)</label>
      <input readonly type="text" name="outras_formacoes_duracao_${index}" id="outras_formacoes_duracao_${index}" value="${$(
        "#outras_formacoes_duracao"
      ).val()}" placeholder="01/2020 - 12/2022" />

  </div>

      <div class="form-group ">
          <label for="">Descrição</label>
          <textarea readonly name="outras_formacoes_descricao_${index}" id="outras_formacoes_descricao_${index}" cols="30" rows="3">${$(
        "#outras_formacoes_descricao"
      ).val()}</textarea>
      </div>

      <hr class="mt mb">
  </div>
      
      `;

      $("#formacao-group").append(htmlData);
      $("#outras_formacoes_centro").val("");
      $("#outras_formacoes_curso").val("");
      $("#outras_formacoes_descricao").val("");
      $("#outras_formacoes_duracao").val("");
      
      this.handleAddFormacao();
    } else {
      let element = args[2];
      $(element).parent().parent().remove();
    }

    let divCampos = document.querySelectorAll(".outras-formacoes");

    let limit = 0;
    for (let campo of divCampos) {
      if ($(campo).data("campo")) {
        limit++;
      }
    }

    if (limit == 3) {
      $("#add-formacao").addClass("d-none");
    } else {
      $("#add-formacao").removeClass("d-none");
    }
  }

  resetExProfissional(args) {
    let index = args[1];

    if (index) {
      let htmlData = `
      <div class="ex-profissional" data-campo="${index}">
      <div class="text-right">
          <i data-campo="${index}" class="fa-sharp fa-solid fa-circle-xmark delete-formacao text-red"></i>
      </div>

      <div class="form-group ">
          <label for="">Projecto/Empresa</label>
          <input readonly="text" name="experiencia_profissional_empresa_${index}" id="experiencia_profissional_empresa_${index}" value="${$(
        "#experiencia_profissional_empresa"
      ).val()}" placeholder="Digita o nome do curso" />

      </div>

      <div class="form-group ">
          <label for="">Função</label>
          <input readonly="text" name="experiencia_profissional_funcao_${index}" id="experiencia_profissional_funcao_${index}" value="${$(
        "#experiencia_profissional_funcao"
      ).val()}" placeholder="Digita o nome do curso" />

      <div class="form-group ">
          <label for="">Duração Duração (MM/AAAA - MM/AAAA)</label>
          <input readonly="text" name="experiencia_profissional_duracao_${index}" id="experiencia_profissional_duracao_${index}" value="${$(
        "#experiencia_profissional_duracao"
      ).val()}" placeholder="Digita o nome do curso" />

      </div>

      <div class="form-group ">
          <label for="">Descrição</label>
          <textarea readonly name="experiencia_profissional_descricao_${index}" id="experiencia_profissional_descricao_${index}" cols="30" rows="3">${$(
        "#experiencia_profissional_descricao"
      ).val()}</textarea>
      </div>

      <hr class="mt mb">
  </div>
      
      `;

      $("#ex-profissional-group").append(htmlData);
      $("#experiencia_profissional_empresa").val("");
      $("#experiencia_profissional_duracao").val("");
      $("#experiencia_profissional_descricao").val("");
      this.handleAddExProfissional();
    } else {
      let element = args[2];
      $(element).parent().parent().remove();
    }

    let divCampos = document.querySelectorAll(".ex-profissional");

    let limit = 0;
    for (let campo of divCampos) {
      if ($(campo).data("campo")) {
        limit++;
      }
    }

    if (limit == 3) {
      $("#add-ex-profissional").addClass("d-none");
    } else {
      $("#add-ex-profissional").removeClass("d-none");
    }
  }

  resetIdioma(args) {
    let index = args[1];

    if (index) {
      let htmlData = `
      <div class="idiomas" data-campo="${index}">
      <div class="text-right">
      <i data-campo="${index}" class="fa-sharp fa-solid fa-circle-xmark delete-idioma text-red"></i>
       </div>

       <div class="form-group ">
       <label for="">Idioma</label>
       <input readonly type="text" name="idioma_${index}"  id="idioma_${index}" value="${$(
        "#idioma"
      ).val()}" />
   </div>
  
      <div class="form-group ">
          <label for="">Proficiência</label>
          <select class="input-small" name="class_idioma${index}" value="<?= get_field('class_idioma' . ($i + 1)) ?>">
              <option ${
                $("#class_idioma").val() == "Nível básico"
                  ? "selected"
                  : 'class="d-none"'
              }    value="Nível básico">Nível básico</option>
              <option ${
                $("#class_idioma").val() == "Nível intermédio"
                  ? "selected"
                  : 'class="d-none"'
              }  value="Nível intermédio">Nível intermédio</option>
              <option ${
                $("#class_idioma").val() == "Nível avançado"
                  ? "selected"
                  : 'class="d-none"'
              }    value="Nível avançado">Nível avançado</option>
              <option ${
                $("#class_idioma").val() == "Nível fluente ou Nativo"
                  ? "selected"
                  : 'class="d-none"'
              }    value="Nível fluente ou Nativo">Nível fluente ou Nativo</option>
          </select>
      </div>
  
      <hr class="mb mt">
    </div>
      
      `;

      $("#idioma-group").append(htmlData);
      $("#idioma").val("");
      $("#class_idioma").val("");

      this.handleAddIdioma();
    } else {
      let element = args[2];
      $(element).parent().parent().remove();
    }

    let divCampos = document.querySelectorAll(".idiomas");

    let limit = 0;
    for (let campo of divCampos) {
      if ($(campo).data("campo")) {
        limit++;
      }
    }

    if (limit == 3) {
      $("#add-idioma").addClass("d-none");
    } else {
      $("#add-idioma").removeClass("d-none");
    }
  }

  resetHabilidade(args) {
    let index = args[1];

    if (index) {
      let htmlData = `
      <div class="habilidades" data-campo="${index}">
          <div class="text-right">
              <i data-campo="${index}" class="fa-sharp fa-solid fa-circle-xmark delete-habilidade text-red"></i>
              </div>

              <div class="form-group ">
              <label for="">Habilidade</label>
              <input readonly type="text" name="habilidade_${index}"  id="habilidade_${index}" value="${$(
        "#habilidade"
      ).val()}" />
          </div>
  

        <div class="form-group ">
            <label for="">Proficiência</label>
            <select class="input-small" name="class_habilidade_${index}" value="${$(
        "#class_habilidade"
      ).val()}>">
              <option ${
                $("#class_habilidade").val() == "Nível básico"
                  ? "selected"
                  : 'class="d-none"'
              }    value="Nível básico">Nível básico</option>
              <option ${
                $("#class_habilidade").val() == "Nível intermédio"
                  ? "selected"
                  : 'class="d-none"'
              }  value="Nível intermédio">Nível intermédio</option>
              <option ${
                $("#class_habilidade").val() == "Nível avançado"
                  ? "selected"
                  : 'class="d-none"'
              }    value="Nível avançado">Nível avançado</option>

          </select>
      </div>
  
      <hr class="mb mt">
    </div>
      
      `;

      $("#habilidade-group").append(htmlData);
      $("#habilidade").val("");
      $("#class_habilidade").val("");

      this.handleAddHabilidade();
    } else {
      let element = args[2];
      $(element).parent().parent().remove();
    }

    let divCampos = document.querySelectorAll(".habilidades");

    let limit = 0;
    for (let campo of divCampos) {
      if ($(campo).data("campo")) {
        limit++;
      }
    }

    if (limit == 3) {
      $("#add-habilidade").addClass("d-none");
    } else {
      $("#add-habilidade").removeClass("d-none");
    }
  }

  resetHabilidadeComportamental(args) {
    let index = args[1];

    if (index) {
      let htmlData = `
      <div class="habilidades-comportamentais" data-campo="${index}">
          <div class="text-right">
              <i data-campo="${index}" class="fa-sharp fa-solid fa-circle-xmark delete-habilidade-comportamental text-red"></i>
              </div>

              <div class="form-group ">
              <label for="">Habilidade</label>
              <input readonly type="text" name="habilidade_${index}"  id="habilidade_${index}" value="${$(
        "#habilidade_comportamental"
      ).val()}" />
          </div>
  
    </div>
      
      `;

      $("#habilidade-comportamental-group").append(htmlData);
      $("#habilidade_comportamental").val("");
     
      this.handleAddHabilidadeComportamental();
    } else {
      let element = args[2];
      $(element).parent().parent().remove();
    }

    let divCampos = document.querySelectorAll(".habilidades-comportamentais");

    let limit = 0;
    for (let campo of divCampos) {
      if ($(campo).data("campo")) {
        limit++;
      }
    }

    if (limit == 3) {
      $("#add-habilidade-comportamental").addClass("d-none");
    } else {
      $("#add-habilidade-comportamental").removeClass("d-none");
    }
  }

  resetHabilitacao(args) {
    let index = args[1];

    if (index) {
      let htmlData = `
      <div class="habilitacao-literaria" data-campo="${index}">
      <div class="text-right">
      <i data-campo="${index}" class="fa-sharp fa-solid fa-circle-xmark delete-habilitacao text-red"></i>
       </div>
  
      <div class="form-group ">
          <label for="">Nível</label>
          <select class="input-small" name="habilitacoes_literarias_nivel_${index}" value="<?= get_field('habilitacoes_literarias_nivel_' . ($i + 1)) ?>" id="habilitacoes_literarias_nivel_${index}" value="<?= get_field('habilitacoes_literarias_nivel_' . ($i + 1)) ?>">
              <option ${
                $("#habilitacoes_literarias_nivel").val() == "Licenciatura"
                  ? "selected"
                  : 'class="d-none"'
              }    value="Licenciatura">Licenciatura</option>
              <option ${
                $("#habilitacoes_literarias_nivel").val() == "Ensino Técnico"
                  ? "selected"
                  : 'class="d-none"'
              }  value="Ensino Técnico">Ensino Técnico</option>
              <option ${
                $("#habilitacoes_literarias_nivel").val() == "Ensino Médio"
                  ? "selected"
                  : 'class="d-none"'
              }    value="Ensino Médio">Ensino Médio</option>
          </select>
      </div>
  
      <div class="form-group ">
          <label for="">Instituição</label>
          <input readonly type="text" name="idioma_${index}"  id="habilitacoes_literarias_instituicao_${index}" value="${$(
        "#habilitacoes_literarias_instituicao"
      ).val()}" placeholder="Digita o nome da Instituição" />
      </div>

      <div class="form-group ">
          <label for="">Duração (MM/AAAA - MM/AAAA)</label>
            <input readonly type="text" name="habilitacoes_literarias_duracao_${index}" id="habilitacoes_literarias_duracao_${index}" value="${$(
              "#habilitacoes_literarias_duracao"
            ).val()}" placeholder="01/2020 - 12/2022" />

      </div>
  
      <div class="form-group ">
          <label for="">Formação</label>
          <input type=" readonly text" name="habilitacoes_literarias_formacao_${index}" " id="habilitacoes_literarias_formacao_${index}" value="${$(
        "#habilitacoes_literarias_formacao"
      ).val()}" placeholder="Digita o nome da Instituição" />
      </div>
      <hr class="mb mt">
    </div>
      
      `;

      $("#habilitacao-group").append(htmlData);
      $("#habilitacoes_literarias_nivel").val("");
      $("#habilitacoes_literarias_instituicao").val("");
      $("#habilitacoes_literarias_formacao").val("");
      $("#habilitacoes_literarias_duracao").val("");
      this.handleAddHabilitacao();
    } else {
      let element = args[2];
      $(element).parent().parent().remove();
    }

    let divCampos = document.querySelectorAll(".habilitacao-literaria");

    let limit = 0;
    for (let campo of divCampos) {
      if ($(campo).data("campo")) {
        limit++;
      }
    }

    if (limit == 3) {
      $("#add-habilitacao").addClass("d-none");
    } else {
      $("#add-habilitacao").removeClass("d-none");
    }
  }

  actualizarCandidato(candidato, args = null) {
    let postID = $("#post_id").val();

    this.loading.showLoadingAnimation()
    $.ajax({
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", maisempregoData.nonce);
      },
      url: maisempregoData.root_url + "/wp-json/wp/v2/candidato/" + postID,
      type: "POST",
      data: candidato,
      success: (response) => {
        this.loading.hideLoadingAnimation()
        show_toast_success("Dados actualizados com sucesso!");

        if(args){
          if (args[0] === "habilitacao") {
            this.resetHabilitacao(args);
          } else if (args[0] === "formacao") {
            this.resetFormacao(args);
          } else if (args[0] === "formacao-mais-emprego") {
            this.resetFormacaoMaisEmprego(args);
          } else if (args[0] === "ex-profissional") {
            this.resetExProfissional(args);
          } else if (args[0] === "idioma") {
            this.resetIdioma(args);
          } else if (args[0] === "habilidade") {
            this.resetHabilidade(args);
          } else if (args[0] === "habilidade-comportamental") {
            this.resetHabilidadeComportamental(args);
          }

        }
      },
      error: (response) => {
        this.loading.hideLoadingAnimation()
        show_toast_error("Ops! Ocorreu um erro!");
        console.log(response);
      },
    });
  }

  handleAddHabilitacao() {
    $("#nova-habilitacao").toggleClass("d-none");

    if ($("#nova-habilitacao.d-none").length) {
      $("#add-habilitacao").removeClass("d-none");
     
      $('#habilitacoes_literarias_nivel').val('')
      $('#habilitacoes_literarias_instituicao').val('')
      $('#habilitacoes_literarias_formacao').val('')
      $('#habilitacoes_literarias_duracao').val('')

    } else {
      $("#add-habilitacao").addClass("d-none");
      
    }
  }

  handleAddFormacaoMaisEmprego() {
  
    $("#nova-formacao-mais-emprego").toggleClass("d-none");

    if ($("#nova-formacao-mais-emprego.d-none").length) {

      $("#add-formacao-mais-emprego").removeClass("d-none");

      $('#formacao_mais_emprego_centro').val('')
      $('#formacao_mais_emprego_curso').val('')
      $('#formacao_mais_emprego_descricao').val('')
      $('#formacao_mais_emprego_duracao').val('')
     
    } else {
     
      $("#add-formacao-mais-emprego").addClass("d-none");
    }
  }

  handleAddFormacao() {
    $("#nova-formacao").toggleClass("d-none");

    if ($("#nova-formacao.d-none").length) {
      $("#add-formacao").removeClass("d-none");

      $('#outras_formacoes_centro').val('')
      $('#outras_formacoes_curso').val('')
      $('#outras_formacoes_descricao').val('')
      $('#outras_formacoes_duracao').val('')
     
    } else {
      $("#add-formacao").addClass("d-none");
     
    }
  }

  handleAddExProfissional() {
    $("#nova-ex-profissional").toggleClass("d-none");

    if ($("#nova-ex-profissional.d-none").length) {
      $("#add-ex-profissional").removeClass("d-none");

      $('#experiencia_profissional_duracao').val('')
      $('#experiencia_profissional_descricao').val('')
      $('#experiencia_profissional_empresa').val('')

    } else {
      $("#add-ex-profissional").addClass("d-none");
    }
  }

  handleAddIdioma() {
    $("#novo-idioma").toggleClass("d-none");

    if ($("#novo-idioma.d-none").length) {
      $("#add-idioma").removeClass("d-none");
      
      $('#idioma').val('')
      $('#class_idioma').val('')
      
    } else {
      $("#add-idioma").addClass("d-none");
  
    }
  }

  handleAddHabilidade() {
    $("#nova-habilidade").toggleClass("d-none");

    if ($("#nova-habilidade.d-none").length) {
      $("#add-habilidade").removeClass("d-none");

      $('#habilidade').val('')
      $('#class_habilidade').val('')

    } else {
      $("#add-habilidade").addClass("d-none");
    }
  }

  handleAddHabilidadeComportamental() {
    $("#nova-habilidade-comportamental").toggleClass("d-none");

    if ($("#nova-habilidade-comportamental.d-none").length) {
      $("#add-habilidade-comportamental").removeClass("d-none");

      $('#habilidade_comportamental').val('')

    } else {
      $("#add-habilidade-comportamental").addClass("d-none");
    }
  }
}

export default Candidato;

